import React from 'react'
import { CardContainer } from './MemberDirectorySettings'
import StyledText from '../../components/StyledComponents/StyledText'
import StyledSwitch from '../../components/StyledComponents/StyledSwitch'
import { Button } from '../../components/form/Button'
import CrossIcon from '../../assets/icons/CrossIcon'
import SaveIcon from '../../assets/icons/SaveIcon'

const Notifications = () => {
    const [notificationsEnabled, setNotificationsEnabled] = React.useState(false);
  return (
    <CardContainer>
        <div className='border-bottom mb-3 pb-3'>
            <StyledText
                fontSize='15px'
                fontWeight={700}
                textColor={'var(--app-primary-color)'}
            >
                Notifications
            </StyledText>
        </div>
        <div className='d-flex align-items-center justify-content-between' style={{ marginBottom: '10px' }}>
            <div>
                <StyledText
                    fontSize='16px'
                    fontWeight={600}
                    textColor={'var(--app-secondary-color)'}
                    className='mb-2'
                >
                    Email Notifications
                </StyledText>
                <StyledText
                    fontSize='14px'
                    fontWeight={500}
                    textColor={'var(--app-text-color)'}
                >
                    Weekly summaries and activity alerts
                </StyledText>
            </div>
            <StyledSwitch checked={notificationsEnabled} onChange={(checked) => setNotificationsEnabled(checked)} />
        </div>
        {/* <div className='d-flex justify-content-end gap-2 mt-4 pb-2'>
            <Button
                btnBg='#ffffff'
                color='rgba(88, 85, 88, 1)'
                borderColor='rgba(186, 189, 193, 1)'
                $variant='customButton'
            >
                <CrossIcon size={20} /> Close</Button>
            <Button
                btnBg={'var(--app-primary-color)'}
                color={'var(--app-text-color)'}
                // borderColor='rgba(186, 189, 193, 1)'
                $variant='customButton'
            >
                <SaveIcon size={20} color={'var(--app-text-color)'} /> Save Changes
            </Button>
        </div> */}
    </CardContainer>
  )
}

export default Notifications